import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=670faa86"
var script = {}
import style0 from "./Carousel.vue?vue&type=style&index=0&id=670faa86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports